import { createSelector } from 'reselect';
import getLatestCartError from './get-latest-cart-error';
import { getLatestCartWarning } from '../features/cart/selectors';

const getCartWarningErrorCrcCode = createSelector(
  getLatestCartError,
  getLatestCartWarning,
  (error, warning) => error?.crcCode || warning?.crcCode,
);

export default getCartWarningErrorCrcCode;
